import React, { useEffect, useState } from "react";
import { Form, OverlayTrigger, Table } from "react-bootstrap";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { withTranslation } from "react-i18next";
import {
  BsExclamationCircleFill
} from "react-icons/bs";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Pagination from "../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  LOADER_COLOR
} from "../../../core/constants/common";
import ImportService from "../../../core/service/ImportService";
import Utils from "../../../core/utilities/Utils";
import "./SupplierImport.scss";

import { BiSearch, BiShareAlt, BiTrash } from "react-icons/bi";
import { CgSortAz } from "react-icons/cg";
import { ScaleLoader } from "react-spinners";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import MessageModal from "../../../components/MessageModal/MessageModal";
import SupplierService from "../../../core/service/SupplierService";
import UtilsService from "../../../core/service/UtilsService";

function ImportDataEdit({ t, response, callbackEdit }) {
  // console.log(response);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [edit, setEdit] = useState({ status: false, id: "", field: "" });
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [selRows, setSelRows] = useState([]);
  const [contact, setContact] = useState("");
  const [phoneCodeCountry, setPhoneCodeCountry] = useState("");
  const [defaultContactCode, setDefaultContactCode] = useState("");
  const [defaultContactId, setDefaultContactId] = useState("");
  const [phoneCode, setPhoneCode] = useState([]);
  const [contactCode, setContactCode] = useState("");
  const [supplierTypesArr, setSupplierTypesArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [color, setColor] = useState(LOADER_COLOR);
  const [isEdited, setIsEdited] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [editdata, setEditData] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmationMessage, setShowConfirmationMessage] = useState("");
  const [action, setAction] = useState("");
  const [title, setTitle] = useState(t("ImportSupplier.label"));
  useEffect(() => {
    getStagedData(0, itemsPerPage);
    getSupplierType();
  }, []);
  const handleContinueEdit = () => {
    if (editdata.length > 0) {
      setLoading(true);
      ImportService.updateStageData(editdata)
        .then((response) => {
          if (response.status === 200) {
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setIsEdited(false);
            getStagedData(currentPage, itemsPerPage);
            setEditData([]);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  const handleBack = () => {
    let obj = {
      type: "Back",
    };
    callbackEdit(obj);
  };
  const getStagedData = (pageNumber, itemsPerPageVal) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }
    setLoading(true);
    ImportService.getStageData(pageNumber, perPage)
      .then((response) => {
        setData(response.data);
        let totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleKeyDown = (event, index, id) => {
    if (event.key === "Enter") {
      handleCancelEdit(id);
    }
  };
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(data.map((item) => item));
    if (isCheckAll) {
      setIsCheck([]);
      setSelRows([]);
    }
    // console.log(isCheck);
  };
  const handleClick = (e, item) => {
    const { id, checked } = e.target;
    const itemId = id ? Number(id) : null;
    setIsCheck([...isCheck, item]);
    if (!checked) {
      setIsCheck(isCheck.filter((check) => check.id !== item.id));
    }
    //const uniqueNames = isCheck.filter((val,id,array) => array.indexOf(val) === id);
    //  console.log(isCheck);
  };
  const handleEdit = (id, field) => {
    setEdit({
      status: true,
      id: id,
      field: field,
    });
  };
  const handleCancelEdit = (id) => {
    // isEdited && setEditData([{ ...editdata }]);
    if (id === edit.id) {
      setEdit({
        status: false,
        id: "",
        field: "",
      });
    }
  };
  const editField = (e, index, id) => {
    let key = e.target.name;
    let value = e.target.value;
    let newData = [];
    const newArr = data.map((obj, i) => {
      if (index === i) {
        setIsEdited(true);
        let myObj = { ...obj };
        if (key === "phoneNumber" || key === "code") {
          value = parseInt(value);
        }
        myObj[key] = value;
        newData = myObj;

        // setEditData(editdata => [...editdata, myObj])
        return myObj;
      }
      return obj;
    });

    if (Object.keys(newData).length > 0) {
      const filtered = editdata.filter((obj) => {
        return obj.id !== id;
      });
      setEditData([...filtered, newData]);
    }
    setData(newArr);
  };

  const getSupplierType = async (e) => {
    var data = JSON.parse(localStorage.getItem("authority"));
    const companyid = data.profile.company.id;
    if (companyid) {
      SupplierService.getSupplierTypes(companyid)
        .then((response) => {
          var res = response.data;
          setSupplierTypesArr([...res]);
        })
        .catch((error) => { });
    }
  };
  const handleContinueStart = () => {
    if (isCheck.length > 0) {
      if (isCheck.find((e) => e.errorMessages !== null)) {
        setShowMessageModal(true);
        setTitle(t("ImportSupplier.label"));
        setModalMessage(t("ImportSupplierWarningMsg.label"));
      } else {
        setAction("Import");
        setTitle(t("ImportSupplier.label"));
        setShowConfirmationModal(true);
        setShowConfirmationMessage(t("ImportSupplierConfirmationMsg.label"));
      }
    } else {
      setModalMessage(t("SelectDataMsg.label"));
      setTitle(t("ImportSupplier.label"));
      setShowMessageModal(true);
    }
  };
  const callbackMessageModal = (boolVal) => {
    setTitle("");
    setShowMessageModal(false);
  };
  const callbackConfirmModal = (boolVal) => {
    setShowConfirmationModal(false);
    if (boolVal) {
      if (action === "Import") {
        if (isCheck.length > 0) {
          let obj = {
            type: "Continue",
          };
          setLoading(true);
          ImportService.importStageData(isCheck)
            .then((response) => {
              if (response.status === 200) {
                toast.success("Success", {
                  position: toast.POSITION.TOP_RIGHT,
                });
                callbackEdit(obj);
              }
            })
            .catch((error) => { })
            .finally(() => {
              setLoading(false);
            });
        } else {
          setModalMessage(t("SelectDataMsg.label"));
          setShowMessageModal(true);
        }
      } else if (action === "Delete") {
        if (isCheck.length > 0) {
          setLoading(true);
          let list = isCheck.map((option) => option.id);
          ImportService.deleteStageData(list)
            .then((response) => {
              console.log("response", response);
              if (response.status === 204) {
                toast.success("Success", {
                  position: toast.POSITION.TOP_RIGHT,
                });
                getStagedData(currentPage, itemsPerPage);
              }
            })
            .catch((error) => { })
            .finally(() => {
              setLoading(false);
            });
        } else {
          setModalMessage(t("SelectDataDeleteMsg.label"));
          setShowMessageModal(true);
        }
      }
    }
    setAction("");
  };
  const getPhoneCodeVal = (data) => {
    if (data.length > 0) {
      setContactCode(data[0].id);
    }
  };
  const getPhoneNumberVal = (data) => {
    setContact(data);
  };
  const getPhoneCodes = () => {
    UtilsService.getPhoneCodes()
      .then((response) => {
        setPhoneCode([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
  };
  const handleDelete = () => {
    if (isCheck.length > 0) {
      setAction("Delete");
      setTitle(t("Confirm.label"));
      setShowConfirmationModal(true);
      setShowConfirmationMessage(t("StagedSupplierDeleteMsg.label"));
    } else {
      setTitle(t("Confirm.label"));
      setModalMessage(t("SelectDataDeleteMsg.label"));
      setShowMessageModal(true);
    }
  };

  return (
    <>
      {loading && (
        <div className="loader-custom">
          <ScaleLoader color={color} loading={true} size={25} />
        </div>
      )}
      <div className="Finalize_dataBox mt-2">
        <div className="Finalize_dataBox_head">
          <h6 className="m-0">{t("EditandFinalizeData.label")}</h6>
          <p>{t("EditStageDataMsg.label")}</p>
        </div>
        <div>
          <div className="List_Table_01">
            <div className="List_table-card01_head">
              <div className="List_table-card_Search_01">
                <div className="List_table-card_Search_Box">
                  <Form>
                    <input type="text" className="form-control" />
                    <Link to="#" className="Search_iocnBox">
                      <BiSearch />
                    </Link>
                  </Form>
                </div>
              </div>
              <div className="List_table-card01_sort">
                <ul>
                  <li>
                    <Link to="#" onClick={handleDelete}>
                      <BiTrash /> {t("Delete.label")}
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <BiShareAlt /> {t("Share.label")}
                    </Link>
                  </li>
                  <li className="filter">
                    <Link to="#">
                      <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card List_table-card01">
              <Table responsive="sm">
                <thead>
                  <tr>
                    <th className="th_check">
                      <Form.Check
                        inline
                        name="selectAll"
                        type="checkbox"
                        id="selectAll"
                        className="m-0"
                        onChange={handleSelectAll}
                        checked={isCheckAll}
                      />
                    </th>
                    <th className="Single_check_width"></th>
                    <th> {t("SupplierName.label")}</th>
                    <th>{t("Email.label")}</th>
                    <th>{t("ContactPerson.label")}</th>
                    <th>{t("ContactNumber.label")}</th>
                    <th>{t("SupplierType.label")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data
                    .filter((val) => val.importStatus === "SAVED")
                    .map((item, index) => (
                      // {data?.map((item, index) => (
                      <tr
                        key={item.id}
                      // onClick={() => handleEdit()}
                      >
                        <td>
                          <Form.Check
                            inline
                            key={item.id}
                            name={item.email}
                            type="checkbox"
                            id={item.id}
                            // onChange={handleClick}
                            onChange={(e) => handleClick(e, item)}
                            // checked={isCheck.includes(item.id)}
                            checked={isCheck.some(
                              (check) => check.id === item.id
                            )}
                            className="m-0"
                          // checked={isCheck[item.invitationId]}
                          />
                        </td>
                        <td>
                          <OverlayTrigger
                            placement="top"
                            overlay={Utils.renderTooltip(item.errorMessages)}
                          >
                            <span>
                              {item.errorMessages ? (
                                <BsExclamationCircleFill className="text-red" />
                              ) : (
                                ""
                              )}
                            </span>
                          </OverlayTrigger>
                        </td>
                        <td onClick={() => handleEdit(item.id, "legalName")}>
                          {edit.status &&
                            edit.field === "legalName" &&
                            edit.id === item.id ? (
                            <input
                              className="edit-control"
                              value={item.legalName}
                              name="legalName"
                              onChange={(e) => editField(e, index, item.id)}
                              onBlur={() => handleCancelEdit(item.id)}
                              onKeyDown={(e) =>
                                handleKeyDown(e, index, item.id)
                              }
                            />
                          ) : (
                            <span>{item?.legalName}</span>
                          )}
                        </td>
                        <td onClick={() => handleEdit(item.id, "email")}>
                          {edit.status &&
                            edit.field === "email" &&
                            edit.id === item.id ? (
                            <input
                              className="edit-control"
                              value={item.email}
                              name="email"
                              onChange={(e) => editField(e, index, item.id)}
                              onBlur={() => handleCancelEdit(item.id)}
                              onKeyDown={(e) =>
                                handleKeyDown(e, index, item.id)
                              }
                            />
                          ) : (
                            <span>{item?.email}</span>
                          )}
                        </td>
                        <td onClick={() => handleEdit(item.id, "name")}>
                          {edit.status &&
                            edit.field === "name" &&
                            edit.id === item.id ? (
                            <input
                              className="edit-control"
                              value={item.name}
                              name="name"
                              onChange={(e) => editField(e, index, item.id)}
                              onBlur={() => handleCancelEdit(item.id)}
                              onKeyDown={(e) =>
                                handleKeyDown(e, index, item.id)
                              }
                            />
                          ) : (
                            <span>{item?.name}</span>
                          )}
                        </td>
                        <td onClick={() => handleEdit(item.id, "contact")}>
                          {edit.status &&
                            edit.field === "contact" &&
                            edit.id === item.id ? (
                            <div>
                              <input
                                type="text"
                                className="edit-control"
                                defaultValue={item?.code}
                                name="code"
                                onChange={(e) => editField(e, index, item.id)}
                                onBlur={() => handleCancelEdit(item.id)}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                onKeyDown={(e) =>
                                  handleKeyDown(e, index, item.id)
                                }
                              />

                              <input
                                type="text"
                                className="edit-control"
                                defaultValue={item?.phoneNumber}
                                name="phoneNumber"
                                onChange={(e) => editField(e, index, item.id)}
                                onBlur={() => handleCancelEdit(item.id)}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                onKeyDown={(e) =>
                                  handleKeyDown(e, index, item.id)
                                }
                              />
                            </div>
                          ) : (
                            <span>
                              {" "}
                              {item?.code}-{item?.phoneNumber}
                            </span>
                          )}
                        </td>
                        {/* <td> <span>
                          
                            {item?.phoneNumber?.code?.phoneCode}-
                            {item?.phoneNumber?.number}
                          </span></td> */}
                        <td onClick={() => handleEdit(item.id, "supplierType")}>
                          {edit.status &&
                            edit.field === "supplierType" &&
                            edit.id === item.id ? (
                            <select
                              className="edit-select"
                              onChange={(e) => editField(e, index, item.id)}
                              onBlur={() => handleCancelEdit(item.id)}
                              onKeyDown={(e) =>
                                handleKeyDown(e, index, item.id)
                              }
                              required
                              name="supplierType"
                              defaultValue={item?.supplierType}
                            >
                              <option value="">{t("Select.label")}</option>
                              {supplierTypesArr.map((type) => (
                                <option value={type.name} key={type.id}>
                                  {type.name}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <span> {item?.supplierType}</span>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              <div className="p-2 List_footer_count">
                <Pagination
                  itemsTotalCount={itemsTotalCount}
                  itemsPerPage={itemsPerPage}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  alwaysShown={true}
                  setItemsPerPage={setItemsPerPage}
                  pageClicked={(pageNum, perPage) => {
                    getStagedData(pageNum, perPage);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="text-center p-2">
            <button
              type="button"
              className="btn btn-secondary me-2 px-4"
              onClick={handleBack}
            >
              {t("Back.label")}
            </button>
            {isEdited ? (
              <button
                type="button"
                className="btn btn-primary px-4 sbmBtn"
                onClick={handleContinueEdit}
              >
                {t("SaveChanges.label")}
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary px-4 sbmBtn"
                onClick={handleContinueStart}
              >
                {t("StartImport.label")}
              </button>
            )}
          </div>
        </div>
      </div>
      {showMessageModal && (
        <MessageModal
          modalShow={true}
          messageText={modalMessage}
          callbackModal={callbackMessageModal}
          id=""
          title={title}
        // title={t("ImportSupplier.label")}
        />
      )}
      {showConfirmationModal && (
        <ConfirmationModal
          modalShow={true}
          messageText={confirmationMessage}
          callbackModal={callbackConfirmModal}
          id=""
          title={title}
        />
      )}
    </>
  );
}
export default withTranslation()(ImportDataEdit);
